<div class="image-upload-progress">
  <mat-progress-spinner
    mode="determinate"
    [value]="output.file.progress.data.percentage"
    diameter="40"
  ></mat-progress-spinner>
</div>
